export default __webpack_public_path__ + "static/media/slime-busd.aa106c90.png";